module.exports = __webpack_public_path__ + "static/media/img005.4735ea0e.jpg";